export default __webpack_public_path__ + "static/media/cumi.386c70a4.svg";